export default __webpack_public_path__ + "static/media/IconDesc_HighSpeedConnector.256.8fc7fcd5.png";